import React from 'react'
import { appWithTranslation } from 'next-i18next'
import { ToastContainer, PageProgressLoader } from '@srca-b2b/kp5-ui-common/lib'
import SpinnerContextProvider from '@srca-b2b/kp5-ui-common/context/SpinnerContext'
import { AuthContext } from '@srca-b2b/kp5-ui-common/context/AuthContext'
import { EfotaOnPremResourceProvider } from '@srca-b2b/kp5-ui-common/context/EfotaOnPremResourceContext'

import '@srca-b2b/kp5-ui-common/themes/bootstrap/_bootstrap.scss'
import '@srca-b2b/kp5-ui-common/themes/usp/_base.scss'
// import '@srca-b2b/kp5-ui-common/themes/styleguide/_base.scss'

/*
    Overrides for our next.js app
    - Persisting layout between page changes
    - Keeping state when navigating pages
    - Inject additional data into pages
    - Add global CSS
    - Inject translations
*/

// Global css to overwrite injected Google Custom Search styles (KP5-1768)
import '../styles/globals.css'

const MyApp = ({ Component, pageProps }) => {
  return (
    <React.StrictMode>
      <AuthContext.Provider value={pageProps.loggedInUser}>
        <SpinnerContextProvider>
          <PageProgressLoader />
          <EfotaOnPremResourceProvider>
            <ToastContainer />
            <Component {...pageProps} />
          </EfotaOnPremResourceProvider>
        </SpinnerContextProvider>
      </AuthContext.Provider>
    </React.StrictMode>
  )
}

export default appWithTranslation(MyApp)

/**
 * Update : as of 23 Jan 2023 -> We added back next-i18next configuration to support different languages for the enrollment process.
 * IMPORTANT: Found that wrapping MyApp with appWithTranslation causes all components
 * in MyApp to be remounted on page change. The expectation is that only NextJS page
 * component <Component {...pageProps} /> is remounted. All other components are
 * expected to persist across page changes. This is a problem because toasts need to
 * persist across page changes. Once we need translations, will need to revisit this.
 * export default appWithTranslation(MyApp, nextI18NextConfig) //  allows us to use the t (translate) function in our components via hooks.
 */
